import { useQuery } from 'react-query';
import axios from 'axios';
import { getProject } from '../common/utils';
import { GetSessionID } from '../../main/MandalaSession';
import jsonpAdapter from '../../logic/axios-jsonp';

/**
 * UseParser calls the Translation tool api at https://ttt.thlib.org/org.thdl.tib.scanner.RemoteScannerFilter
 * which parses a Tibetan phrase into its discrete units, returning a list of units and their Kmaps Term ID.
 *
 * This currently calls the TTT directly using JSONP call, but there is also a proxy in the mandala-proxy
 * custom module on the WP site that will call the translation tool through the path /proxy/ttt/?text=
 */

export const getParsedTibPhrase = async (tibPhrase, filterval, parser) => {
    if (tibPhrase?.length > 0) {
        if (filterval < 1) {
            filterval = 1;
        }
        tibPhrase = tibPhrase.replace(/[\r\n]+/g, ' ');
        // console.log("Parser in get parsedTibPhrase", parser);

        // Make request
        let request;
        if (parser === 'php') {
            request = {
                url: '/wp-json/tibetan/v1/parse',
                params: {
                    dicts: filterval,
                    text: tibPhrase,
                },
            };
        } else {
            request = {
                adapter: jsonpAdapter,
                callbackParamName: 'jwf',
                url: 'https://ttt.thlib.org/org.thdl.tib.scanner.RemoteScannerFilter',
                params: {
                    dicts: filterval,
                    text: tibPhrase,
                },
            };
        }

        const { data } = await axios.request(request);
        let retdata = data && data.response ? data.response : data;
        return retdata;
    }
    return null;
};

export function useParser(tibData, filterval, byPass = false, options = {}) {
    const newOptions = { enabled: !byPass, ...options };
    const parser = newOptions?.parser ?? 'java';
    delete newOptions?.parser;
    return useQuery(
        ['translate', tibData],
        () => getParsedTibPhrase(tibData, filterval, parser),
        newOptions
    );
}
